import classnames from 'classnames';
import { SfaMatchMetaProps } from './sfaMatchMeta.types';
import styles from './sfaMatchMeta.module.scss';

const SfaMatchMeta = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-match-meta',
  rows,
}: SfaMatchMetaProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.sfaMatchMeta, classNames)}
  >
    {rows.map((row, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={`${row.value}-${idx}`} className={styles.row}>
        {row.icon ? <span className={styles.icon}>{row.icon}</span> : null}
        {row.label ? <span className={styles.label}>{row.label}</span> : null}
        <span className={styles.value}>{row.value}</span>
      </div>
    ))}
  </div>
);

export default SfaMatchMeta;
